import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Header from "../components/header/Header";
// import teams from "../assets/data/team";
import banner1 from "../assets/images/banner1.png";
import banner2 from "../assets/images/banner2.png";
import banner3 from "../assets/images/banner3.png";
import banner4 from "../assets/images/banner4.png";
import banner5 from "../assets/images/banner5.png";
import bg_dot from "../assets/images/bg_dot.png";
import bg from "../assets/images/bg.jpeg";
import hhh from "../assets/images/lienminhhhh.png";
import hho from "../assets/images/lienminhhhd.png";
import fmcg from "../assets/images/groupfmcg.png";
import vhe from "../assets/images/groupvhe.png";
import hang1 from "../assets/images/hang1.png";
import hang2 from "../assets/images/hang2.png";
import hang3 from "../assets/images/hang3.png";
import hangkhac from "../assets/images/hangkhac.png";
import giaithuong from "../assets/images/giaithuong.png";
import hunghaumungtruyenthong from "../assets/images/hunghaumungtruyenthong2.png";
import niemtinHUNGHAU from "../assets/images/niemtinHUNGHAU.png";
import Minigame from "../assets/images/Minigame.png";
import samset from "../assets/images/samset.png";
import huyhieutapthe from "../assets/images/huyhieutapthe.png";
import huyhieucanhan from "../assets/images/huyhieucanhan.png";
import hang1canhan from "../assets/images/hang1canhan.png";
import hang2canhan from "../assets/images/hang2canhan.png";
import hang3canhan from "../assets/images/hang3canhan.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CustomCarousel from "../components/Slider/slider";
import { result } from "../controller";

const initialTasks = [
  {
    id: "1",
    title: "Nhiệm vụ 01: +20 điểm",
    description: (
      <>
        <b>
          Tự quay và đăng tải một video clip review chân thực, hấp dẫn về sản
          phẩm hoặc dịch vụ của Ngôi nhà Hùng Hậu.
        </b>
        <br />
        Độ dài clip: 1-3 phút
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Chất lượng video: Hình ảnh rõ nét, ánh sáng tốt, âm thanh rõ ràng.
          </li>
          <li>
            Chủ thể nội dung video là trải nghiệm chân thực về sản phẩm/ dịch vụ
            của Ngôi nhà Hùng Hậu (Sản phẩm FMCG, khóa học, lớp học tại VHE...)
          </li>
          <li>
            Đăng trên các kênh truyền thông MXH của bạn (ví dụ: YouTube,
            Facebook, Instagram Reels, TikTok).
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "2",
    title: "Nhiệm vụ 02: +10 điểm",
    description: (
      <>
        <b>
          Đăng tải bài viết review kèm hình ảnh về sản phẩm/ dịch vụ của Ngôi
          nhà Hùng Hậu.
        </b>
        <br />
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Chất lượng: Hình ảnh chất lượng, rõ nét</li>
          <li>
            Yêu cầu: Hình ảnh tự chụp, tự thiết kế, tự vẽ, sáng tạo...liên quan
            đến các sản phẩm/ dịch vụ của Ngôi nhà Hùng Hậu (Sản phẩm FMCG, khóa
            học, lớp học tại VHE...). Không sử dụng hình ảnh có sẵn từ internet.
          </li>
          <li>
            Đăng trên các kênh truyền thông MXH của bạn (ví dụ: Facebook,
            Instagram Reels, TikTok...).
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "3",
    title: "Nhiệm vụ 03: +5 điểm",
    description: (
      <>
        <b>
          Đăng tải hình ảnh chụp cá nhân hoặc tập thể tại các sự kiện hoặc cơ sở
          của Ngôi nhà Hùng Hậu.
        </b>
        <br />
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Hình ảnh cá nhân/tập thể rõ nét, phù hợp với tiêu chí của chương
            trình.
          </li>
          <li>
            Đăng trên các kênh truyền thông MXH của bạn (ví dụ: Facebook,
            Instagram Reels, TikTok...).
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "4",
    title: "Nhiệm vụ 04: +1 điểm",
    description: (
      <>
        <b>
          Chia sẻ công khai các bài đăng từ các trang mạng xã hội chính thức của
          các Group/ ĐVTV thuộc Ngôi nhà Hùng Hậu.
        </b>
        <br />
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Đảm bảo bài đăng được chia sẻ ở chế độ công khai trên các tài khoản
            MXH cá nhân, nhóm, hoặc trang cộng đồng
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
];

const teams = [
  {
    key: "hhh",
    name: "HHH",
    bg: "from-blue-400 to-blue-700",
    border: "border-blue-700",
    text: "text-blue-900",
    gradient: "bg-gradient-to-br from-blue-400 to-blue-700",
    selected: true,
    icon: hhh,
  },
  {
    key: "hho",
    name: "HHO++",
    bg: "from-orange-400 to-orange-700",
    border: "border-orange-400",
    text: "text-orange-900",
    gradient: "bg-gradient-to-br from-orange-300 to-orange-500",
    selected: false,
    icon: hho,
  },
  {
    key: "fmcg",
    name: "FMCG",
    bg: "from-green-400 to-green-700",
    border: "border-green-400",
    text: "text-green-900",
    gradient: "bg-gradient-to-br from-green-300 to-green-500",
    selected: false,
    icon: banner1,
  },
  {
    key: "vhe",
    name: "VHE",
    bg: "from-blue-100 to-blue-300",
    border: "border-blue-200",
    text: "text-blue-900",
    gradient: "bg-gradient-to-br from-blue-100 to-blue-300",
    selected: false,
    icon: banner1,
  },
  {
    key: "andco",
    name: "&CO",
    bg: "from-pink-400 to-pink-600",
    border: "border-pink-400",
    text: "text-pink-900",
    gradient: "bg-gradient-to-br from-pink-300 to-pink-500",
    selected: false,
    icon: banner1,
  },
];

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels // Đăng ký plugin để hiển thị nhãn dữ liệu trên biểu đồ
);

const prizes = [
  {
    name: "Giải Nhất",
    description: "Description for Prize 1",
    image:
      "https://images.unsplash.com/photo-1745849610268-f81d7aed915b?q=80&w=3213&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Giải Nhì",
    description: "Description for Prize 2",
    image:
      "https://images.unsplash.com/photo-1745849610268-f81d7aed915b?q=80&w=3213&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Giải Ba",
    description: "Description for Prize 3",
    image:
      "https://images.unsplash.com/photo-1745849610268-f81d7aed915b?q=80&w=3213&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Giải Khuyến Khích",
    description: "Description for Prize 4",
    image:
      "https://images.unsplash.com/photo-1745849610268-f81d7aed915b?q=80&w=3213&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Giải Đặc Biệt",
    description: "Description for Prize 5",
    image:
      "https://images.unsplash.com/photo-1745849610268-f81d7aed915b?q=80&w=3213&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Giải Thưởng Khác",
    description: "Description for Prize 6",
    image:
      "https://images.unsplash.com/photo-1745849610268-f81d7aed915b?q=80&w=3213&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

export const options = (title) => {
  return {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      datalabels: {
        align: "end", // align at end of bar
        anchor: "", // anchor to end of bar
        offset: 4, // small space from edge
        color: "white",
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => {
          return value > 0 ? value : null; // only show if > 0
        },
        clamp: true, // prevent from going outside chart
      },
      legend: {
        display: false,
      },
      tooltip: {
        // backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        // borderColor: "transparent",
        // borderWidth: 1,
      },
      title: {
        display: true,
        text: title,
        color: "white",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff", // màu chữ trên trục X
        },
      },
      y: {
        ticks: {
          color: "#ffffff", // màu chữ trên trục Y
        },
      },
    },
  };
};
const labels = teams.map((team) => team.name);
export const data = {
  labels,
  datasets: [
    {
      label: "",
      data: [0, 0, 0, 0, 0, 0], // Dữ liệu sẽ được cập nhật sau khi fetch
      borderColor: "white",
      // backgroundColor random color
      backgroundColor: [
        "#2F00FF",
        "#FFA20D",
        "41B0FF",
        "C8FFB7",
        "D4FF5E",
        "#FF7474",
      ],
    },
  ],
};

export default function Events() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(initialTasks);
  const [openTask, setOpenTask] = useState(null);
  const [groupData, setGroupData] = useState(data);
  const [teamsData, setTeamsData] = useState(teams);
  const [topUserData, setTopUserData] = useState(data);
  const [selectedTeam, setSelectedTeam] = useState("hhh");

  const TaskPopup = ({ task, onClose }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#0091EB]/90 rounded-2xl shadow-xl max-w-2xl max-md:max-w-full max-md:mx-4 w-full py-4 relative animate-fadeIn">
        <div className="transform -translate-y-8 scale-[1.02] border w-full bg-gradient-to-b from-[#07B4FE] to-[#0044D7] rounded-3xl relative z-10 flex items-center justify-center leading-tight h-fit p-4">
          <button
            className="absolute top-2 right-4 text-2xl text-white hover:text-red-500"
            onClick={onClose}
          >
            &times;
          </button>
          <h2 className="bg-gradient-to-b leading-normal text-5xl max-lg:text-2xl text-center from-[#FFD942] via-[#FFA22F] to-[#FF7E22] bg-clip-text text-transparent font-bold">
            {task.title}
          </h2>
        </div>
        <div className="text-white text-xl px-6">{task.description}</div>
      </div>
    </div>
  );

  const fetchGroupResult = async () => {
    try {
      const response = await result.getTeamsResult();
      const data = Object.entries(response)
        .sort((a, b) => b[1] - a[1])
        .map(([key, value]) => ({ key, value }));
      setTeamsData(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getTop10Result = async () => {
    try {
      const response = await result.getTop10Result();
      setTopUserData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // cách 1 phút lấy dữ liệu
    // fetch trước 1 lần
    fetchGroupResult();
    getTop10Result();
    const interval = setInterval(() => {
      fetchGroupResult();
      getTop10Result();
    }, 60000);
    return () => clearInterval(interval);
  }, []);
  const scrollToSection = (id) => {
    // setShowMenu(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 200); // Wait for menu to close
  };
  return (
    <div
      style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover" }}
      className=" min-h-screen pb-10 relative"
    >
      <Header />
      <div className="w-11/12  mx-auto p-4">
        {/* Popup Task */}
        {openTask && (
          <TaskPopup task={openTask} onClose={() => setOpenTask(null)} />
        )}
        <div className="banner flex items-stretch justify-between max-md:flex-col max-md:items-start max-md:gap-4 mt-10 mb-20">
          <div className="banner_left basis-5/12 flex flex-col items-start justify-center pr-4">
            <img src={Minigame}></img>
            <img className="mt-4" src={niemtinHUNGHAU}></img>
            <span className="text-lg text-white mt-4 mr-4 font-medium max-w-md">
              Trở thành nhà sáng tạo nội dung và “đại sứ” lan tỏa niềm tin Hùng
              Hậu, cùng tham gia hoàn thành nhiệm vụ và giành chiến thắng!
            </span>
            <button
              onClick={() => scrollToSection("section-nhiemvu")}
              className="mt-4 text-[20px] px-8 py-3  bg-gradient-to-r from-[#FFDD1F] to-[#FF530A] text-white rounded-2xl hover:opacity-90 transition-opacity"
            >
              XEM NHIỆM VỤ
            </button>
          </div>
          <div className="banner_right basis-7/12 gap-4  items-end ">
            <img
              className="max-h-[500px] col-span-3  w-full object-cover"
              src={hunghaumungtruyenthong}
              alt="img-1"
            />
          </div>
        </div>

        <div
          id="section-nhiemvu"
          className="grid grid-cols-2 gap-4 max-md:grid-cols-1 mt-40 items-stretch"
        >
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-4">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner2}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "1"))}
                className=" bg-white hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className=" text-2xl max-lg:text-lg text-center bg-gradient-to-br from-[#F1039C] to-[#B8C2CE] bg-clip-text text-transparent font-bold overflow-clip w-full">
                  NHIỆM VỤ 1
                </h2>
              </div>
            </div>
            <div className="flex flex-col gap-4 grow">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner3}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "2"))}
                className="bg-gradient-to-b hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 from-[#FF530A] to-[#FFDD1F] rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className="text-white text-2xl max-lg:text-lg text-center text-transparent font-bold">
                  NHIỆM VỤ 2
                </h2>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-4">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner4}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "3"))}
                className="bg-gradient-to-b hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 from-[#21FF30] to-[#008709] rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className=" text-2xl max-lg:text-lg text-center text-white font-bold overflow-clip w-full">
                  NHIỆM VỤ 3
                </h2>
              </div>
            </div>
            <div className="flex flex-col gap-4 grow">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner5}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "4"))}
                className="bg-gradient-to-b hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 from-[#0017AF] to-[#0F2FFF] rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className="bg-gradient-to-b text-2xl max-lg:text-lg text-center from-[#00FCED] to-[#B8C2CE] bg-clip-text text-transparent font-bold">
                  NHIỆM VỤ 4
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div
          id="section-thele"
          className="bg-[#0059FFC4] bg-opacity-75 rounded-2xl p-1 shadow-lg mt-40"
        >
          <div className="bg-[#0059FFC4] bg-opacity-75 rounded-2xl relative pt-10">
            {/* Header */}
            <div className="flex w-full items-center rounded-full p-4 justify-between mb-4 bg-[#00AAFFE5] absolute -top-[40px] left-1/2 transform -translate-x-1/2">
              <h2 className="font-black  w-full text-white text-xl md:text-2xl mx-auto tracking-widest text-center">
                THỂ LỆ CUỘC THI
              </h2>
            </div>
            {/* Content */}
            <div className="text-white text-base md:text-xl space-y-4 p-6">
              <div className="mt-4 ">
                <span className="font-bold">Bước 1: </span> Bắt đầu cuộc thi
                bằng cách nhấp vào chọn đội thi.
              </div>
              <div className="mt-4">
                <span className="font-bold">Bước 2:</span> Mỗi cửa sổ của đội sẽ
                hiển thị 04 nhiệm vụ – bạn có thể{" "}
                <span className="font-bold">
                  thực hiện 1 trong 4 nhiệm vụ bất kỳ
                </span>
                , không giới hạn số lần trong ngày.
                <br></br>
                <span>
                  👉 Mỗi nhiệm vụ sẽ cộng điểm khác nhau cho kết quả của cá nhân
                  và của đội:
                </span>
                <ul className="list-disc pl-8 mt-2 space-y-1 text-white/90">
                  <li className="">
                    Nhiệm vụ 1: Đăng clip review sản phẩm/ dịch vụ thực tế của
                    ngôi nhà Hùng Hậu{" "}
                    <span className="font-bold">(+ 20 điểm)</span>
                  </li>
                  <li>
                    Nhiệm vụ 2: Đăng ảnh review sản phẩm/ dịch vụ thực tế của
                    ngôi nhà Hùng Hậu .{" "}
                    <span className="font-bold">(+ 10 điểm)</span>
                  </li>
                  <li>
                    Nhiệm vụ 3: Chia sẻ hình ảnh cá nhân/ tập thể tại các sự
                    kiện và cơ sở của Ngôi nhà Hùng Hậu.{" "}
                    <span className="font-bold">(+05 điểm)</span>
                  </li>
                  <li>
                    Nhiệm vụ 4: Chia sẻ ở chế độ công khai các bài đăng từ các
                    trang MXH của Ngôi nhà Hùng Hậu{" "}
                    <span className="font-bold">(+01 điểm)</span>
                  </li>
                </ul>
              </div>
              <div className="mt-4">
                <span className="font-bold">Bước 3:</span> Sau khi hoàn thành
                nhiệm vụ, quay trở lại đội của mình tại trang minigame dán link
                bài đăng vừa chia sẻ vào ô “Nhập link kết quả nhiệm vụ”, rồi
                bấm “Gửi kết quả” để hệ thống xét duyệt và ghi nhận
              </div>
              <div className="mt-4">
                <span className="font-bold">Bước 4:</span> Tiếp tục thực hiện
                nhiệm vụ mỗi ngày và theo dõi <b> bảng xếp hạng</b> cá nhân và
                tập thể để cùng đồng đội chinh phục ngôi vị dẫn đầu!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="section-doithi"
        className="w-full rounded-2xl p-1 shadow-lg mt-40 relative"
      >
        <div
          // style={{ backgroundImage: `url(${bg_dot})`, backgroundSize: "cover", opacity: 1 }}
          className=" rounded-2xl p-8  z-20 relative"
        >
          <img
            className="absolute top-0 left-0 w-full h-full object-cover opacity-60 -z-10"
            src={bg_dot}
          ></img>
          <div className="text-center font-extrabold text-xl md:text-3xl text-white mb-8 tracking-wide z-20 mt-16">
            CHỌN ĐỘI ĐỂ THỰC HIỆN NHIỆM VỤ
          </div>
          <div className="flex justify-center gap-4 flex-wrap max-md:grid grid-cols-4 max-md:grid-cols-2 mb-16">
            <img
              onClick={() => {
                navigate(`/user/teams/fmcg`);
              }}
              className="max-h-96 hover:cursor-pointer"
              src={fmcg}
            ></img>
            <img
              onClick={() => {
                navigate(`/user/teams/hhh`);
              }}
              className="max-h-96 hover:cursor-pointer"
              src={hhh}
            ></img>
            <img
              onClick={() => {
                navigate(`/user/teams/vhe`);
              }}
              className="max-h-96 hover:cursor-pointer"
              src={vhe}
            ></img>
            <img
              onClick={() => {
                navigate(`/user/teams/hho`);
              }}
              className="max-h-96 hover:cursor-pointer"
              src={hho}
            ></img>
          </div>
          <div className="flex justify-center gap-4 flex-wrap mt-2 max-md:grid grid-cols-2"></div>
        </div>
      </div>

      <div className="w-11/12 mx-auto">
        <div
          id="section-xephang"
          className="w-full grid grid-cols-2 gap-10 max-md:grid-cols-1 p-4 rounded-2xl mt-40"
        >
          <div className="w-full h-full flex flex-col gap-2 bg-[#B9FFFC]/20 rounded-2xl p-8">
            <div className="flex items-center gap-4 justify-center">
              <img
                src={huyhieucanhan}
                className=" h-14 object-cover"
                alt="Huy Hiệu Cá Nhân"
              />
              <h1 className="text-2xl font-bold text-white text-center ">
                BẢNG XẾP HẠNG CÁ NHÂN
              </h1>
            </div>
            {topUserData.length > 0 ? (
              <div className=" rounded-2xl flex flex-col h-full">
                <ul className="flex flex-col grow justify-start">
                  {topUserData.map((user, index) => (
                    <li
                      key={index}
                      className="bg-white px-3 mb-2 flex justify-center items-center gap-6 rounded-lg shadow-md"
                    >
                      <div className="relative w-[10%] max-md:w-[15%] flex items-center justify-center">
                        <img
                          alt="avatar"
                          src={
                            index == 0
                              ? hang1canhan
                              : index == 1
                              ? hang2canhan
                              : index == 2
                              ? hang3canhan
                              : hangkhac
                          }
                          className="w-full h-fit rounded-full object-cover max-md:object-cover"
                        />
                        {index > 2 && (
                          <span
                            className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-[#1900FB] font-bold text-lg pointer-events-none"
                            style={{
                              textShadow: "0 0 6px #000, 0 0 2px #000",
                            }}
                          >
                            {index + 1}
                          </span>
                        )}
                      </div>
                      <div className="flex flex-col w-[60%]">
                        <span className="text-lg font-bold text-[#0009BC]">
                          {user?.user365?.displayName}
                        </span>
                        <span className="text-sm text-gray-500">
                          ĐƠN VỊ: {user?.user365?.displayName.split(" ")[0]}
                        </span>
                      </div>
                      <span className="flex items-center gap-2 w-[30%] justify-end">
                        {user.totalScore} điểm{" "}
                        <img className="w-5 h-5" src={samset}></img>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div className="bg-white rounded-2xl p-4 flex flex-col items-center">
                <p className="text-lg">Đang tải dữ liệu...</p>
              </div>
            )}
          </div>
          <div className="w-full h-full flex flex-col gap-2 bg-[#B9FFFC]/20 rounded-2xl p-8">
            <div className="flex items-center gap-4 justify-center">
              <img
                src={huyhieutapthe}
                className="w-16 h-16"
                alt="Huy Hiệu Tập Thể"
              />
              <h1 className="text-2xl font-bold text-white text-center ">
                BẢNG XẾP HẠNG TẬP THỂ
              </h1>
            </div>
            {teamsData.length > 0 ? (
              <div className=" rounded-2xl flex flex-col h-full">
                <ul className="flex flex-col justify-between">
                  {teamsData.map((team, index) => (
                    <li
                      key={index}
                      className="bg-white px-3 mb-2 h-14 flex justify-center items-center gap-6 rounded-lg shadow-md"
                    >
                      <div className="relative w-[10%] max-md:w-[15%] flex items-center justify-center">
                        <img
                          alt="avatar"
                          className="w-full h-fit rounded-full object-cover"
                          src={
                            index == 0
                              ? hang1
                              : index == 1
                              ? hang2
                              : index == 2
                              ? hang3
                              : hangkhac
                          }
                        />
                        {index > 2 && (
                          <span
                            className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-[#1900FB] font-bold text-lg pointer-events-none"
                            style={{
                              textShadow: "0 0 6px #000, 0 0 2px #000",
                            }}
                          >
                            {index + 1}
                          </span>
                        )}
                      </div>
                      <div className="flex flex-col w-[60%]">
                        <span className="text-lg font-bold text-[#0009BC]">
                          {team?.key.toUpperCase()}
                        </span>
                        <span className="text-sm text-[#0009BC]">
                          {team?.key == "Đội Harmony"
                            ? "Liên minh HHH - HHO - HHC"
                            : team?.key == "Đội Heart"
                            ? "GROUP VHE"
                            : team?.key == "Đội House"
                            ? "Group FMCG"
                            : team?.key == "Đội Aurora"
                            ? "HHD - RIVERS - &CO"
                            : null}
                        </span>
                      </div>
                      <span className="flex items-center gap-2 w-[30%] max-md:w-[25%] justify-end">
                        {team.value} điểm{" "}
                        <img className="w-5 h-5" src={samset}></img>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div className="bg-white rounded-2xl p-4 flex flex-col items-center">
                <p className="text-lg">Đang tải dữ liệu...</p>
              </div>
            )}
          </div>
          {/* <div className="w-full h-full">
              <Bar options={options("ĐỘI THI")} data={groupData} />
            </div> */}
        </div>

        <div id="section-giaithuong" className="mt-40">
          <img
            src={giaithuong}
            className="w-full object-cover rounded-3xl"
          ></img>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
